export enum EUserType {
  /** Собственник **/
  Homeowner = 'homeowner',
  /** Специалист **/
  Specialist = 'specialist',
  /** Неопределенный **/
  Undefined = 'undefined',
}
